<template>
  <div class="page">
    <div class="page-wrapper">
      <div v-if="pageMode === 'manage'" class="pageModeManage">
        <h1>Welkom bij de CDT-Blog,</h1>
        <p>
          Op deze pagina zie je een overzicht van de artikelen zichtbaar op de
          publieke blog.
        </p>
        <p>
          Selecteer een blog om deze te bewerken. Of voeg een volledig nieuwe
          blog post toe.
        </p>
        <div class="blogPreviewList">
          <div
            class="blogPreview add"
            @click="
              ;(selectedBlogId = newBlogId), (selectedBlogEditable = newBlog)
            "
          >
            <h3>+</h3>
            <h3>Voeg blog toe</h3>
          </div>
          <div
            v-for="blog in blogs"
            :key="blog.id"
            @click=";(selectedBlogId = blog.id), (selectedBlogEditable = blog)"
            class="blogPreview"
          >
            <div class="content">
              <h3>{{ blog.titel }}</h3>
              <span>{{ blog.datum }}</span>
              <p>{{ blog.body }}</p>
            </div>
            <div class="toolbar">
              <span v-if="blog.shownOnHomepage">
                Featured
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pageMode === 'edit'" class="pageModeEdit">
        <h1>{{ selectedBlog.titel }}</h1>

        <div class="fullEditor">
          <div class="editBar">
            <div>
              <span @click="cancelBlogEdit()">← Terug naar overzicht</span>
              <div
                v-if="!selectedBlogEditable.shownOnHomepage"
                style="opacity:.6"
                @click="
                  ;(selectedBlogEditable.shownOnHomepage = true),
                    (isEdited = isEdited + 1)
                "
              >
                Feature op homepage
              </div>
              <div
                v-if="selectedBlogEditable.shownOnHomepage"
                style="border:2px solid #3076ea"
                @click="
                  ;(selectedBlogEditable.shownOnHomepage = false),
                    (isEdited = isEdited + 1)
                "
              >
                Feature op homepage
              </div>
            </div>
            <div>
              <span
                style="background-color:#f1646c !important;color:white;font-weight:500;"
                @click="verwijder()"
                >Verwijder</span
              >
              <span v-if="isEdited > 1" class="button" @click="log"
                >Sla op en publiceer</span
              >
              <span v-else class="button" style="opacity:.5;"
                >Sla op en publiceer</span
              >
            </div>
          </div>

          <div class="edit">
            <span>Titel:</span>
            <input
              @input="isEdited = isEdited + 1"
              type="text"
              v-model="selectedBlogEditable.titel"
            />
            <span>Artikel:</span>
            <VueEditor
              v-if="selectedBlogId"
              :editorToolbar="customToolbar"
              @text-change="isEdited = isEdited + 1"
              v-model="selectedBlogEditable.bodyHTML"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'
import { VueEditor } from 'vue2-editor'
export default {
  components: { VueEditor },
  data () {
    return {
      selectedBlogId: '',
      selectedBlogEditable: {},
      newBlog: {
        titel: 'Titel van je blog hier',
        bodyHTML: '',
        datum: '',
        shownOnHomepage: false
      },
      isEdited: 0,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block', 'link'],
        [{ color: [] }, { background: [] }],
        [{ size: ['small', false, 'large', 'huge'] }]
      ]
    }
  },

  created () {
    store.dispatch('fetchBlogs')
  },
  computed: {
    newBlogId () {
      return this.blogs.length + 1
    },
    blogs () {
      //? Only return the blogs, not the 'blogsinfo' document that holds previews
      return store.state.blogs.blogs.filter(blog => blog.id !== 'blogsinfo')
    },
    pageMode () {
      if (!this.selectedBlogId) return 'manage'
      return 'edit'
    },
    selectedBlog () {
      if (this.selectedBlogId !== this.newBlogId) {
        return this.blogs.filter(blog => blog.id === this.selectedBlogId)[0]
      } else {
        return { titel: 'Nieuw blog artikel' }
      }
    }
  },
  methods: {
    loadInBlogForEditing (id) {
      this.selectedBlogId = id
      this.selectedBlogEditable = this.selectedBlog
      this.isEdited = false
    },
    log () {
      console.log(this.selectedBlogEditable)
      if (this.selectedBlog.titel !== 'Nieuw blog artikel') {
        store.dispatch('updateBlog', {
          ...this.selectedBlogEditable,
          body: this.selectedBlogEditable.bodyHTML.replace(/<(.|\n)*?>/g, '')
        })
        this.isEdited = 1
      } else {
        store.dispatch('voegBlogToe', this.selectedBlogEditable)
        this.isEdited = 1
        this.cancelBlogEditSkip()
      }
    },
    verwijder () {
      if (confirm('Weet je zeker dat je dit artikel wilt verwijderen?')) {
        store.dispatch('verwijderBlog', this.selectedBlogId)
        this.cancelBlogEditSkip()
      }
    },
    cancelBlogEdit () {
      console.log(this.isEdited)

      if (this.isEdited > 1) {
        if (confirm('Eventuele wijzigingen worden niet opgeslagen')) {
          store.dispatch('fetchBlogs')
          this.selectedBlogId = ''
          this.selectedBlogEditable = ''
          this.isEdited = 0
          this.newBlog = {
            titel: 'Titel van je blog hier',
            bodyHTML: '',
            datum: '',
            shownOnHomepage: false
          }
        }
      } else {
        this.cancelBlogEditSkip()
      }
    },
    cancelBlogEditSkip () {
      store.dispatch('fetchBlogs')
      this.selectedBlogId = ''
      this.selectedBlogEditable = ''
      this.isEdited = 0
      this.newBlog = {
        titel: 'Titel van je blog hier',
        bodyHTML: '',
        datum: '',
        shownOnHomepage: false
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.page-wrapper
  max-width: 1100px
  margin: 0 auto
.pageModeManage
  height: 50vh
  .blogPreviewList
    display: flex
    justify-content: space-between
    flex-wrap: wrap


  .blogPreview
    &.add
      display: flex
      align-items: center
      justify-content: center
      color: #3076ea
      border: 2px solid #3076ea
      background-color: rgba(00, 00, 00, 0)
      font-size: 22px
    margin-top: 6%
    cursor: pointer
    background-color: white
    min-width: 47%
    box-sizing: border-box
    transition: .2s
    border-radius: 10px
    display: flex
    flex-direction: column
    justify-content: space-between
    overflow: hidden
    box-shadow: 0 10px 20px rgba(00, 00, 00, 0.1)
    width: 47%
    .content
      padding: 5%
      h3
        font-size: 18px
        font-weight: 500
      span
        font-size: 14px
        padding-top: 10px
        display: block
        opacity: .5
      p
        font-size: 14px
        margin-top: 20px
        max-height: 6vh
        opacity: .7
        overflow: hidden
    .toolbar
      background-color: #e4ecfa
      height: 58px
      box-sizing: border-box
      display: flex
      align-items: center
      justify-content: space-between
      padding: 0 20px
      font-size: 15px
      span
        border: 1px solid #3076ea
        color: #3076ea
        border-radius: 5px
        padding: 3px 5px
        background-color: white
    &:hover
      transform: translateY(-5px)
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.15)

.fullEditor
  box-shadow: 0 20px 50px rgba(00, 00, 00, 0.1)
  border-radius: 14px
  border: 1px solid rgba(00, 00, 00, 0.2)
  overflow: hidden
  margin-top: 40px
  input
    border: none
    font-size: 24px
    width: 100%
    padding: 10px 0
    font-weight: 600
    border-bottom: 1px solid lightgray
    margin-bottom: 30px

.edit
  background-color: white
  padding: 30px
  border-radius: 10px
  border-top-left-radius: 0
  border-top-right-radius: 0
  overflow: hidden

.editBar
  background-color: #e4ecfa
  div
    display: flex
  div > *
    color: black
    padding: 6px 10px 4px 10px
    background-color: white
    cursor: pointer
    border-radius: 10px
    font-size: 14px
    margin-right: 14px

  .button
    background-color: #3076ea
    margin-right: 0
    color: white
    font-weight: 500
  padding: 8px
  border-radius: 14px
  border-bottom-left-radius: 0
  border-bottom-right-radius: 0
  display: flex
  justify-content: space-between
  flex-direction: row
</style>
